import React from "react";
import DashboardShell from "../../Shared/DashboardShell";

// Only the broadcaster's tabs. Everything else -- the sidebar, the responsive
// behaviour, the auth redirect -- is DashboardShell, shared with the
// advertiser side so the two stay mirrored.

const TABS = [
    { to: "/vendor-dashboard/devices", label: "My screens" },
    { to: "/vendor-dashboard/payout", label: "Payout & balance" },
    { to: "/vendor-dashboard/profile", label: "Profile" },
];

export default function VendorDashboard() {
    // "vendor_id", not the active role: a dual-role account must be able to
    // open this dashboard whichever side it is currently looking at.
    // "Host", not "Broadcaster". The internal model is still `vendor` in the
    // database, the JWT and every route -- renaming that is a migration, not a
    // copy change -- but no business owner calls themselves a broadcaster, and
    // this heading is the first word they read after logging in.
    return <DashboardShell title="Host" tabs={TABS} requires="vendor_id" />;
}
